import React from "react";
import "./ManualSection.css";

/*
  Material Icons Outlined - make sure it's loaded in your index.html
  Add this to public/index.html in the <head>:
  <link href="https://fonts.googleapis.com/icon?family=Material+Icons+Outlined" rel="stylesheet" />
*/

const ManualSection = () => {
  return (
    <section className="manual" id="engagement" aria-label="Engagement section">
      <div className="manual__wrap">
        {/* LEFT */}
        <div className="manual__left">
          <h2 className="manual__title">
            Build Stronger Fatherhood Programs
            <br />
            In Your Community.
          </h2>

          <p className="manual__lead">
            Community Impact Solutions LLC supports organizations and individuals through consulting and training in fatherhood leadership, family engagement, and behavioral health. We believe in strengthening families, equipping them with tools, and strengthening our community.
          </p>

          <ul className="manual__list" aria-label="What we help with">
            <li className="manual__item">
              <div className="manual__text">
                <strong>Family-Centered Program Design</strong>
                <span>
                  Working with organizations to develop or refine family programs with the focus on cultural responsiveness, accessibility, and real-world impact.
                </span>
              </div>
            </li>

            <li className="manual__item">
              <div className="manual__text">
                <strong>Father Engagement</strong>
                <span>
                  An approachable and practical plan to support and strengthen father involvement and remove barriers.
                </span>
              </div>
            </li>

            <li className="manual__item">
              <div className="manual__text">
                <strong>Community Outreach</strong>
                <span>
                  Strategy and facilitation to expand organizational reach and build authentic community relationships, strengthening those around us.
                </span>
              </div>
            </li>
          </ul>
        </div>

        {/* RIGHT */}
        <div className="manual__right" aria-hidden="true">
          <div className="manual__imageFrame">
            <div className="manual__imageContainer">
              <img
                className="manual__image"
                src="/image4.jpg"
                alt="Professional consulting discussion"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ManualSection;